export default "__VITE_ASSET__DtZGMMCW__"